import { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { LANGUAGES } from '../../../i18n/languages';
import { buildLocalizedPath, stripLanguageFromPath } from '../../../i18n/routing';

type SeoLinksProps = {
  baseUrl?: string;
  canonicalPath?: string;
  includeXDefault?: boolean;
};

const SeoLinks = ({
  baseUrl = 'https://fruvin.com',
  canonicalPath,
  includeXDefault = true
}: SeoLinksProps) => {
  const location = useLocation();
  const path = canonicalPath ?? location.pathname;
  const canonicalUrl = `${baseUrl}${path}`;
  const basePath = stripLanguageFromPath(path);
  const xDefaultLanguage = LANGUAGES[0];

  return (
    <Helmet>
      <Fragment>
        <link rel="canonical" href={canonicalUrl} />
        {LANGUAGES.map((language) => {
          const localizedPath = buildLocalizedPath(basePath, language);
          return (
            <link
              key={language}
              rel="alternate"
              hrefLang={language}
              href={`${baseUrl}${localizedPath}`}
            />
          );
        })}
        {includeXDefault && (
          <link
            rel="alternate"
            hrefLang="x-default"
            href={`${baseUrl}${buildLocalizedPath(basePath, xDefaultLanguage)}`}
          />
        )}
      </Fragment>
    </Helmet>
  );
};

export default SeoLinks;
